<template>
<div style="background-color: white">
	<link href="https://cdn.jsdelivr.net/npm/bootstrap-italia@1.6.4/dist/css/bootstrap-italia.min.css" rel="stylesheet">

  <header class="it-header-wrapper">
    <div class="it-nav-wrapper">
	    <div class="it-header-center-wrapper">
		    <div class="container-fluid">
			    <div class="row">
				    <div class="col-8">
					    <div class="it-header-center-content-wrapper">
						    <div class="it-brand-wrapper">
							    <a href="#">
								    <img src='/img/logo-vim.svg' class="logo-h">
								    <div class="it-brand-text">
									    <h2 class="no_toc">Ministero dello sviluppo economico</h2>
									    <h3 class="no_toc d-none d-md-block">Voucher Innovation Manager</h3>
								    </div>
							    </a>
						    </div>
					    </div>
				    </div>
			    </div>
		    </div>
	    </div>
    </div>
  </header>
	
	<main>
		<div class="d-flex flex-column align-center my-8 mx-2 simulazione-step-2">
			
			<h5 class="text-uppercase font-weight-bold">SPORTELLO INFORMATICO PER L'INVIO DELLA DOMANDA VOUCHER INNOVATION MANAGER</h5>
			
			<div v-if="alertType" class="alert alert-warning mt-6" role="alert">
				<span v-html="risultatoSimulazione.message"></span>
			</div>
			
			<div v-else class="mt-6">
				<v-row class="font-weight-bold" style="font-size: 20px">
					Simulazione eseguita! Hai impiegato:
				</v-row>
				
				<v-row class="mt-2 title" :style="'color: ' + risultatoSimulazione.colore" justify="center">
					{{ risultatoSimulazione.tempoImpiegato }} secondi
				</v-row>
				
				<!--<v-row v-if="risultatoSimulazione.countAltriUtenti > 0" class="mt-2" justify="center">-->
				<!--	<span v-if="risultatoSimulazione.countAltriUtenti == 1">Un cliccatore ha fatto un tempo migliore del tuo! Ha impiegato <b>{{ risultatoSimulazione.minimoAltriUtenti }}</b> secondi</span>-->
				<!--	<span v-else>{{risultatoSimulazione.countAltriUtenti}} cliccatori hanno fatto un tempo migliore del tuo! Il migliore ha impiegato <b>{{ risultatoSimulazione.minimoAltriUtenti }}</b> secondi</span>-->
				<!--</v-row>-->
				
				<div v-if="risultatoSimulazione.provaGratuita" class="mt-4 font-weight-bold" style="font-size: 20px">
					<v-row justify="center">
						Vuoi avere il tempo preciso al millesimo e tutte le statistiche?
					</v-row>
					<v-row justify="center">
						<a href="https://simulatoreclickday.it/prezzi/" style="text-align:center; text-decoration: none;" class="error--text" target="_blank">
							ACQUISTA UNO DEI NOSTRI PACCHETTI!
						</a>
					</v-row>
				</div>
			</div>
			
			<div class="my-6 d-flex align-center justify-center">
				<button @click="goBack()" class="btn btn-primary mr-6">Torna alla Home</button>
				<button @click="prossimaSimulazione()" class="btn btn-primary">Prossima simulazione</button>
			</div>
			
			<v-snackbar v-model="snackbar.showSnackbar" bottom :timeout="10000" v-if="snackbar.alertType != null && snackbar.message != null" :color="(snackbar.alertType == 'warning' ? 'warning' : (snackbar.alertType != 'error' ? scdColor : 'error'))">
				{{ snackbar.message }}
				<v-btn color="white" text @click="snackbar.alertType = null">
					Chiudi
				</v-btn>
			</v-snackbar>
		</div>
	</main>
	
	<footer class="it-footer" id="sticky-footer">
		<div class="it-footer-main">
			<div class="container">
				<section>
					<div class="row clearfix">
						<div class="col-sm-12">
							<div class="it-brand-wrapper">
								<a href="#">
									<img src='img/logo-vim.svg' class="logo-b">
									<div class="it-brand-text">
										<h2 class="no_toc">Ministero dello sviluppo economico</h2>
										<h3 class="no_toc d-none d-md-block">Voucher Innovation Manager</h3>
									</div>
								</a>
							</div>
						</div>
					</div>
				</section>
				<section>
					<div class="row">
						<div class="col-lg-6 col-md-6 col-sm-6 pb-2">
							<h4>
								<a href="#" title="Vai alla pagina: Contatti">Contatti </a>
							</h4>
							<div class="link-list-wrapper">
								<ul class="footer-list link-list clearfix">
									<li><a class="list-item" href="#" title="Contattaci">managerinnovazione.istanzedgiai@mise.gov.it</a></li>
									<li><span class="list-item">06 64892998 (lunedì-venerdì 9:00-17:00)</span></li>
								</ul>
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-6">
							<h4>
								<a href="#" title="Vai alla pagina: Documenti">Documenti</a>
							</h4>
							<div class="link-list-wrapper">
								<ul class="footer-list link-list clearfix">
									<li><a class="list-item" target="_blank" href="#" title="Vai alla pagina: Istruzioni operative">Istruzioni operative</a></li>
									<li><a class="list-item" target="_blank" href="#" title="Vai alla pagina: Scheda su Voucher per Consulenza in innovazione">Scheda su Voucher per Consulenza in innovazione</a></li>
								</ul>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="it-footer-small-prints clearfix">
			<div class="container">
				<h3 class="sr-only">Sezione Link Utili</h3>
				<ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
					<li class="list-inline-item">
						<a class="nav-link" href="#" target="_blank">Privacy policy</a>
					</li>
				</ul>
			</div>
		</div>
	</footer>
</div>
</template>

<script>
export default {
	data() {
		return {
			alertType: null,
			
			risultatoSimulazione: {
				// DATI IN ARRIVO DAL LOCAL STORAGE
				bandoId: null,
				provaGratuita: null,
				message: null,
				tempoImpiegato: null,
				colore: null,
				minimoAltriUtenti: null,
				// countAltriUtenti: null,
			},
			
			snackbar: {
				showSnackbar: false,
				message: null,
				alertType: null,
			}
			
		};
	},
	created() {
		this.risultatoSimulazione = JSON.parse(localStorage.getItem('risultatoSimulazioneVim'));
		
		if(this.risultatoSimulazione.hasError == true){
			this.alertType = "error";
			this.message = this.risultatoSimulazione.message;
		}
		
		this.tempoImpiegato = this.risultatoSimulazione.tempoImpiegato ;
		this.colore = this.risultatoSimulazione.colore;
	},
	
	mounted() {
		let scriptTag = document.createElement("script");
		scriptTag.src = "https://cdn.jsdelivr.net/npm/bootstrap-italia@1.6.4/dist/js/bootstrap-italia.bundle.min.js";
		scriptTag.id = "bootstrap-1-6-4";
		document.getElementsByTagName('head')[0].appendChild(scriptTag);
	},
	
	methods: {
		goBack: function() {
			window.location.href = "/home";
		},
		async prossimaSimulazione() {
			try {
				// Controllo se l'utente può fare simulazioni
				// let response = await axios.get('/utentePuoFareLaSimulazione');
				// const utentePuoFareLaSimulazione = response.data.utentePuoFareLaSimulazione;
				
				// if (!utentePuoFareLaSimulazione) {
				//   this.snackbar.alertType = "warning";
				//   this.snackbar.message = response.data.message;
				//   this.snackbar.showSnackbar = true;
				//   return
				// }
				
				// Ottengo id e data_ora della prossima simulazione
				let response = await axios.get('/ottieniProssimaSimulazione');
				const idSimulazione = response.data.id;
				const dataOraSimulazione = response.data.data_ora;
				const route = response.data.bando.route;
				
				// Controllo se ho già premuto il bottone "Prossima simulazione"
				if(this.isEnteringSimulazione) return;
				this.isEnteringSimulazione = true;
				
				// Controllo se ho skippato simulazioni:
				response = await axios.get(`/cliccatore/accediSimulazione/${idSimulazione}/${this.risultatoSimulazione.bandoId}/${dataOraSimulazione}`)
				
				// salvo la simulazione sul database
				axios.post('/salvaSimulazione', {
						id: idSimulazione,
						dataOra: dataOraSimulazione
					})
					.then(response => {
						console.log('r');
						if (response.data.hasError) {
							this.snackbar.alertType = "error";
							this.snackbar.message = response.data.message;
							this.snackbar.alertColor = 'red';
							this.snackbar.showSnackbar = true;
							
						} else {
							this.$router.push({ name: route });
						}
					})
					.catch(error => {
						this.snackbar.alertType = "error";
						this.snackbar.message = "Errore, impossibile avviare la simulazione";
						this.snackbar.alertColor = 'red';
						this.snackbar.showSnackbar = true;
					});
				
				
			} catch (error) {
			
			}
		},
	},
};
</script>

<style lang="scss" scoped>
* {
	font-family: "Titillium Web",Geneva,Tahoma,sans-serif !important;
}

.logo-b {
	width: 60px;
	margin-right: 15px;
}

.logo-h {
	width: 90px;
	margin-right: 25px;
	margin-bottom: 15px;
}
a.navbar-brand {
	white-space: normal;
	text-align: center;
	word-break: break-all;
}

.sticky-offset{
	top: 80px;
}

/* Sticky footer styles
-------------------------------------------------- */
html {
	font-size: 14px;
	position: relative;
	min-height: 100%;
}
@media (min-width: 768px) {
	html {
		font-size: 16px;
		position: relative;
		min-height: 100%;
	}
}

@media(max-width: 768px) {
	.dx-menu {
		display: none;
	}
}

@media(max-width: 990px) {
	.it-nav-wrapper img {
		width: 60px;
		margin-right: 15px;
	}
}


button.accept-policy {
	font-size: 1rem;
	line-height: inherit;
}

html,
body {
	height: 100%;
}

#page-content {
	flex: 1 0 auto;
}

#sticky-footer {
	flex-shrink: none;
}
</style>
